<template>
  <div class="status-bar">
    <timeline-step status="active" :step="1" title="Not Yet Submitted" :maximumStep="stepCount">
      <template v-slot:title><div class="red">Not Yet Submitted</div></template>
      <template v-slot:caption>
        <NotSubmittedText />
      </template>
    </timeline-step>

    <timeline-step
      v-for="step in steps"
      :key="step.id"
      :status="step.status"
      :step="step.step"
      :title="step.title"
      :maximumStep="stepCount"
      :configuration="step"
      @titleClicked="currentstep = $event"
      @todoListClicked="emit('todoListClicked')"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, defineEmits } from "vue";
import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestone } from "@/models/applicationStatus";
import NotSubmittedText from "@/components/application-statuses/NotSubmitted/NotSubmittedText.vue";

useStore();

const emit = defineEmits<{
  (e: "todoListClicked"): void;
}>();

const { timeline, currentstep, stepCount } = useApplicationStatus();

const steps = computed(() => timeline.value.filter((s: TimelineMilestone) => s.step > 1));
</script>
<style scoped>
.red {
  color: red;
}
</style>
